// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.criteria.RentalManagerUserPropertyCriteriaV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyCriteriaV2WebApiHandler_set } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyCriteriaSetV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Args {
  postData: UserPropertyCriteriaSetV2RequestDto;
}

export type RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Args
>;

/**
 * Set criteria for a listing
 */
export const useRentalManagerUserPropertyCriteriaV2WebApiHandler_set = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Args) =>
      RentalManagerUserPropertyCriteriaV2WebApiHandler_set(args.postData, httpClient),
  });
};
